export default {
	computed: {
		loadingSession() {
			return this.$store.state.session.loading
		}
	},
	methods: {
		async startSession() {
			const success = await this.$store.dispatch('session/start')
			if (success) this.$router.push({ name: 'Vote' })
		}
	}
}
